import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup } from "reactstrap";
import { P } from "../../AbstractElements";
import DressCode from "./DressCode";
import RiwayatPenyakit from "./RiwayatPenyakit";

const PreviewJawaban = ({ watch, control, setValue }) => {
  // Mendapatkan data anggota keluarga dari form
  const anggotaKeluarga = watch("anggota_keluarga") || [];

  return (
    <div className="preview-jawaban">
      <h3 className="text-dark">Pratinjau Isian Bapak/Ibu</h3>
      <P>Silakan periksa kembali data yang telah diisi. Jika semua sudah benar dan lengkap, mohon tekan tombol <b>Kirim</b> untuk menyimpan jawaban Anda.</P>
      <br /><br />

      {/* Preview Data Diri */}
      <div className="purple-header mb-4 bg-primary">
        <h3 className="text-white p-3">Anggota Keluarga</h3>
      </div>

      <div className="form-section-content">
        <FormGroup style={{border: "1px solid #ccc", padding: "20px", borderRadius: "5px"}}>
          <label className="bg-transparent font-weight-bold">Nama Peserta Utama</label>
          <P>{watch("nama") || "-"}</P>
        </FormGroup>

        {/* Preview Anggota Keluarga */}
        <div className="mt-4">
          <h5 className="mb-3">Anggota keluarga yang akan ikut aktivitas hari ke 3 bersama Bapak/Ibu</h5>
          
          {anggotaKeluarga.map((anggota, index) => (
            anggota && anggota.nama && (
              <FormGroup 
                key={index} 
                style={{
                  border: "1px solid #ccc", 
                  padding: "20px", 
                  borderRadius: "5px",
                  marginBottom: "15px"
                }}
              >
                <h6 className="mb-3">Anggota Keluarga {index + 1}</h6>
                
                <div className="mb-3">
                  <label className="d-block font-weight-bold">Nama</label>
                  <P>{anggota.nama || "-"}</P>
                </div>
                
                <div className="mb-3">
                  <label className="d-block font-weight-bold">Umur</label>
                  <P>{anggota.umur || "-"} tahun</P>
                </div>
              </FormGroup>
            )
          ))}
          
          {anggotaKeluarga.filter(anggota => anggota && anggota.nama).length === 0 && (
            <P>Tidak ada anggota keluarga yang ditambahkan.</P>
          )}
        </div>
      </div>

      {/* Bagian transportasi dihilangkan */}
      
      <br />
      <DressCode control={control} watch={watch} setValue={setValue} preview={true} />
      <br />
      <RiwayatPenyakit control={control} watch={watch} setValue={setValue} preview={true} />
      
      <style jsx>{`
        .field-label {
          font-weight: 500;
          margin-bottom: 0.5rem;
        }
        .field-value {
          min-height: 38px;
        }
        .preview-section {
          break-inside: avoid;
        }
        .section-header {
          border-radius: 8px;
        }
      `}</style>
    </div>
  );
};

export default PreviewJawaban;